export default __webpack_public_path__ + "static/media/team.136f1db1.png";